import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import WebsiteMemberListLayer from "../components/WebsiteMemberListLayer";

const WebsiteMemberListPage = () => {
    return (
        <MasterLayout>
            <WebsiteMemberListLayer />
        </MasterLayout>
    );
};

export default WebsiteMemberListPage;
